module.exports = __webpack_public_path__ + "img/Android-active.fd6a8cc.svg";